export default "__VITE_ASSET__f052437e__"